export default class Emitter {

    constructor() {
        this.events = {};
    }

    on(type, callback) {
        if(!(type in this.events)) {
            this.events[type] = [];
        }
        this.events[type].push(callback);
    }

    off(type, callback=null) {
        if (callback && type in this.events) {
            const newList = [];
            for (let cb of this.events[type]) {
                if (cb !== callback) {
                    newList.push(cb);
                }
            }
            this.events[type] = newList;
        } else {
            delete this.events[type];
        }
    }

    trigger(type, event={}) {
        if (type in this.events) {
            event.type = type;
            for (let cb of this.events[type]) {
                cb.call(this, event);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./source/scripts/utils/emitter.js